import React, { createContext, ReactNode, useEffect, useState } from 'react'
import { getLatestGeneralSettingWithTimeZoneValue } from '../../services/generalSetting';
import Cookies from 'js-cookie';
import useTenant from '../hooks/useTenant';
import useAuth from '../hooks/useAuth';

const GeneralContext = createContext({});

export const GeneralProvider = ({ children }: { children: ReactNode }) => {
    const { handleTenantError }: any = useTenant();
    const { auth }: any = useAuth();
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const [dateFormat, setDateFormat] = useState<string>("MM/DD/YYYY");
    const [timeZoneName, setTimezoneName] = useState<string>("");
    const [generalSetting, setGeneralSetting] = useState<any | null>(null);

    useEffect(() => {
        if (tenantId) {
            getLatestGeneralSettingWithTimeZoneValue(tenantId)
                .then(response => {
                    if (!response) {
                        setDateFormat("MM/DD/YYYY");
                    }

                    const data = response;
                    setGeneralSetting(data);

                    let tzName = "UTC"; // fallback
                    if (data?.timezoneName) {
                        const match = data.timezoneName.match(/\((.*?)\)\s(.*?)\s/);
                        if (match && match[2]) tzName = match[2];
                    }
                 
                    setTimezoneName(tzName);

                    if (data?.preferredDateFormat) {
                        switch (parseInt(data?.preferredDateFormat)) {
                            case 0:
                            case 4:
                                setDateFormat("MM/DD/YYYY");
                                break;
                            case 1:
                            case 2:
                                setDateFormat("YYYY-MM-DD");
                                break;
                            case 3:
                                setDateFormat("DD-MM-YYYY");
                                break;
                            case 5:
                                setDateFormat("DD/MM/YYYY");
                                break;
                            case 6:
                            case 8:
                                setDateFormat("DD.MM.YYYY");
                                break;
                            case 7:
                                setDateFormat("DD-MMM-YYYY");
                                break;
                            default:
                                setDateFormat("MM/DD/YYYY");
                        }
                    } else {
                        setDateFormat("MM/DD/YYYY");
                    }
                    handleTenantError(null);
                })
                .catch(error => {
                    setDateFormat("MM/DD/YYYY");
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tenantId, auth])

    const value = { dateFormat, setDateFormat, timeZoneName, setTimezoneName, generalSetting, setGeneralSetting };

    return (
        <GeneralContext.Provider value={value}>
            {children}
        </GeneralContext.Provider>
    )
}
export default GeneralContext
